<template>
  <div class="d-flex align-items-center flex-column">
    <div class="image-panel image-panel-3 bg-success rounded-circle mb-2">
      <div class="material-icons text-white" style="font-size:4rem">done</div>
    </div>
    <h5 class="mb-4 text-mcf-color">{{ content }}</h5>
    <b-button @click="goRedeemHistory" class="bg-customize border-customize mb-3 px-5">{{ useImmediatelyWording }}</b-button>
    <b-button @click="goRedeemList" variant="light" class="px-5 mb-3">{{ keepShoppingWording }}</b-button>
    <table class="mb-3 font-size-md text-mcf-color" align="top" style="max-width:360px;">
      <tr>
        <th valign="top" class="text-nowrap px-1">{{ redeemTimeWording }}</th>
        <td valign="top" class="text-break-word px-1">{{ date }}</td>
      </tr>
      <tr>
        <th valign="top" class="text-nowrap px-1">{{ redeemItemWording }}</th>
        <td valign="top" class="text-break-word px-1">
          <template v-for="name in giftNames">
            <p :key="name" class="mb-0">{{ name }}</p>
          </template>
        </td>
      </tr>
      <tr>
        <th valign="top" class="text-nowrap px-1">{{ usePointWording }}</th>
        <td valign="top" class="text-break-word px-1">{{ subtotal | currency }}{{ pointUnit }}</td>
      </tr>
    </table>
  </div>
</template>

<script>
import pageSettingGetter from '@/utils/pageSettingGetter';

export default {
  data() {
    return {
      // 兌禮完成內容文案
      content: '',
      // 立即使用文案
      useImmediatelyWording: '',
      // 繼續購物文案
      keepShoppingWording: '',
      // 兌禮日期文案
      redeemTimeWording: '',
      // 兌禮內容文案
      redeemItemWording: '',
      // 使用點數文案
      usePointWording: '',
      // 點數單位
      pointUnit: '',
      // 今天日期
      date: '',
      // 兌禮禮品名字
      giftNames: [],
      // 總計
      subtotal: 0,
    };
  },
  methods: {
    // 前往兌禮列表頁
    goRedeemList() {
      const vm = this;
      vm.$router.push({ name: 'redeemList', query: { companyid: vm.$store.state.companyId, membersourceid: vm.$store.state.memberSourceId } });
    },
    // 前往兌禮歷程
    goRedeemHistory() {
      const vm = this;
      vm.$router.push({ name: 'redeemHistory', query: { companyid: vm.$store.state.companyId, membersourceid: vm.$store.state.memberSourceId } });
    },
  },
  created() {
    const vm = this;

    // 取得頁面設定
    vm.$store.dispatch('getPageSetting', 'RedeemItem')
      .then((setting) => {
        vm.content = pageSettingGetter.getFunctionWording(setting, 'CartRedeemCompletedContent');
        vm.useImmediatelyWording = pageSettingGetter.getFunctionWording(setting, 'CartRedeemCompletedButton');
        vm.keepShoppingWording = pageSettingGetter.getFunctionWording(setting, 'CartRedeemCompletedBackToShopButton');
        vm.redeemTimeWording = pageSettingGetter.getFunctionWording(setting, 'CartRedeemCompletedSaleTimeWording');
        vm.redeemItemWording = pageSettingGetter.getFunctionWording(setting, 'CartRedeemCompletedRedeemListWording');
        vm.usePointWording = pageSettingGetter.getFunctionWording(setting, 'CartRedeemCompletedUsePointWording');
        vm.pointUnit = pageSettingGetter.getFunctionWording(setting, 'UserPointUnit');
      });

    const { date, subtotal, gifts } = vm.$route.query;

    // 資料不完整，前往錯誤頁
    if (!date || (!subtotal && subtotal !== 0) || !gifts) {
      vm.$router.push({ name: 'Error' });
    }

    vm.date = date;
    vm.subtotal = subtotal;
    // 兌禮禮品名字
    // 如傳回非陣列(object)，把它包成陣列來做顯示
    vm.giftNames = Array.isArray(gifts) ? gifts : [gifts];
  },
};
</script>

<style>

</style>
